import React from "react";
import { Box, Typography, IconButton, Badge, Skeleton } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
const CustomerOrderTableHeader = ({
  tableInfo,
  branch,
  cart,
  searchQuery,
  onSearchChange,
  onCartOpen,
  searchResults,
  isMobile,
  logo,
  IMAGE_BASE_URL,
  logoLoading = false,
}) => {
  console.log("🎨 CustomerOrderTableHeader - logo:", logo);
  console.log("🎨 CustomerOrderTableHeader - logoLoading:", logoLoading);

  const defaultLogo = "https://cdn-icons-png.flaticon.com/512/3132/3132693.png";
  const logoUrl = logo ? `${IMAGE_BASE_URL}${logo}` : defaultLogo;

  return (
    <>
      {/* عرض رقم الطاولة */}
      {tableInfo && (
        <Box sx={{ 
          textAlign: "center", 
          py: { xs: 1.25, sm: 1.75, md: 2 },
          bgcolor: "#fffbe6",
          borderBottom: "2px solid #ffe0b2",
          position: "sticky",
          top: 0,
          zIndex: 1101,
          boxShadow: "0 2px 8px rgba(255, 179, 0, 0.1)",
        }}>
          <Typography 
            sx={{ 
              color: "#ff3d3d", 
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 18 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.5,
            }}
          >
            <Box component="span" sx={{ 
              display: { xs: 'none', sm: 'inline' },
              fontSize: { sm: 18, md: 20 }
            }}>
              🪑
            </Box>
            {isMobile ? `طاولة ${tableInfo.table_name}` : `رقم الطاولة: ${tableInfo.table_name}`}
          </Typography>
        </Box>
      )}

      {/* شريط بيانات الفرع والسلة */}
      <Box
        sx={{
          width: "100%",
          bgcolor: "#fffbe6",
          borderBottom: "2px solid #ffe0b2",
          px: { xs: 1.25, sm: 2.5, md: 6 },
          py: { xs: 0.875, sm: 1.25, md: 1.75 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 0.75, sm: 1.5 },
          boxShadow: "0 2px 12px 0 #ffe0b222",
          position: "sticky",
          top: tableInfo ? { xs: 45, sm: 52, md: 58 } : 0,
          zIndex: 1100,
        }}
      >
        <Box sx={{ 
          display: "flex", 
          alignItems: "center", 
          gap: { xs: 0.75, sm: 1.5 },
          flex: 1,
          minWidth: 0,
        }}>
          {logoLoading ? (
            <Skeleton
              variant="rectangular"
              sx={{
                width: { xs: 32, sm: 40, md: 44 },
                height: { xs: 32, sm: 40, md: 44 },
                borderRadius: { xs: 1.5, sm: 2 },
              }}
            />
          ) : (
            <Box
              component="img"
              src={logoUrl}
              alt="logo"
              onLoad={() => console.log("✅ تم تحميل اللوجو بنجاح")}
              onError={(e) => {
                console.error("❌ فشل تحميل اللوجو، استخدام الافتراضي");
                e.target.src = defaultLogo;
              }}
              sx={{
                width: { xs: 32, sm: 40, md: 44 },
                height: { xs: 32, sm: 40, md: 44 },
                borderRadius: { xs: 1.5, sm: 2 },
                bgcolor: "#fff",
                boxShadow: "0 2px 8px #ffb30022",
                flexShrink: 0,
                objectFit: "contain",
                p: 0.5,
              }}
            />
          )}
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              sx={{
                fontWeight: 800,
                color: "#ff3d3d",
                fontSize: { xs: 13, sm: 16, md: 18 },
                lineHeight: 1.2,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {branch?.name || ""}
            </Typography>
            {branch?.address && !isMobile && (
              <Typography sx={{ 
                color: "#888", 
                fontSize: { sm: 12, md: 13 }, 
                lineHeight: 1.3,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}>
                {branch.address}
              </Typography>
            )}
          </Box>
        </Box>
        <IconButton
          onClick={onCartOpen}
          sx={{
            bgcolor: "#fff",
            border: "2px solid #ffb300",
            color: "#ffb300",
            boxShadow: "0 2px 8px #ffb30033",
            width: { xs: 38, sm: 44, md: 48 },
            height: { xs: 38, sm: 44, md: 48 },
            transition: "all 0.2s",
            flexShrink: 0,
            "&:hover": {
              bgcolor: "#ffb300",
              color: "#fff",
              transform: "scale(1.05)",
            },
          }}
        >
          <Badge 
            badgeContent={cart.length} 
            color="error"
            sx={{
              '& .MuiBadge-badge': {
                fontSize: { xs: 10, sm: 11 },
                minWidth: { xs: 16, sm: 18 },
                height: { xs: 16, sm: 18 },
              }
            }}
          >
            <ShoppingCartIcon sx={{ fontSize: { xs: 20, sm: 24, md: 26 } }} />
          </Badge>
        </IconButton>
      </Box>

      {/* شريط البحث */}
      <Box sx={{ 
        px: { xs: 1.25, sm: 2.5, md: 6 },
        py: { xs: 1.5, sm: 2, md: 2.5 },
      }}>
        <Box sx={{ 
          position: "relative",
          maxWidth: { xs: "100%", sm: 550, md: 750 },
          mx: "auto"
        }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: "#fff",
            borderRadius: { xs: 2.5, sm: 3, md: 3.5 },
            boxShadow: "0 3px 12px rgba(255, 179, 0, 0.12)",
            border: "2px solid #ffe0b2",
            px: { xs: 1.5, sm: 2 },
            py: { xs: 0.875, sm: 1, md: 1.125 },
            transition: "all 0.2s",
            "&:focus-within": {
              borderColor: "#ffb300",
              boxShadow: "0 4px 16px rgba(255, 179, 0, 0.2)",
            }
          }}>
            <SearchIcon sx={{ 
              color: "#ffb300", 
              fontSize: { xs: 22, sm: 26, md: 28 },
              mr: { xs: 0.75, sm: 1 },
              flexShrink: 0,
            }} />
            <input
              type="text"
              placeholder="ابحث عن منتج..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                fontSize: isMobile ? "13px" : "15px",
                fontFamily: "Cairo, Arial, sans-serif",
                backgroundColor: "transparent",
                color: "#222",
                minWidth: 0,
              }}
            />
            {searchQuery && (
              <IconButton
                onClick={() => onSearchChange("")}
                size="small"
                sx={{ 
                  color: "#ff3d3d",
                  p: { xs: 0.5, sm: 0.75 },
                  ml: { xs: 0.5, sm: 0.75 },
                  "&:hover": { 
                    bgcolor: "#fff3f3",
                    transform: "scale(1.1)",
                  },
                  transition: "all 0.2s",
                }}
              >
                <ClearIcon sx={{ fontSize: { xs: 18, sm: 22 } }} />
              </IconButton>
            )}
          </Box>
          {searchQuery && (
            <Typography sx={{ 
              mt: 0.75, 
              textAlign: "center", 
              color: "#888",
              fontSize: { xs: 11, sm: 12 },
              fontWeight: 500,
            }}>
              {searchResults ? `✨ ${searchResults.reduce((sum, r) => sum + r.products.length, 0)} منتج` : "❌ لا توجد نتائج"}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default CustomerOrderTableHeader;
